export const APP_STARTED = '[APP] APP STARTED SUCCESSFUL';
export const LOGGED_IN = '[APP] LOGGED IN';
export const LOG_OUT = '[APP] LOGGED OUT';
